import React from 'react';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import { buildMarketDataKeys } from '../../../../../../../stores/websocketStore/utils/marketDataRouting';
import { observer } from 'mobx-react-lite';
import { TopRowBox } from '../../../../../tradeplans/activeTradePlanModule/components/topRows/topRowBox/TopRowBox';
import { colors } from '../../../../../../../colorVars';

const BidAskBox = observer(({ symbol, dataSource, brokerage }) => {
  const { priceDataStore } = useWebsocketStore();

  const hash = buildMarketDataKeys({ symbol, dataSource, brokerage }).find(
    (key) => priceDataStore.lastQuote[key]
  );
  const { bid, ask } = (hash && priceDataStore.lastQuote[hash]) ?? { bid: 0, ask: 0 };
  return (
    <>
      <TopRowBox width="100px" backgroundColor={colors.grey} color={colors.lightGrey}>{`Bid: ${bid !== undefined ? bid.toFixed(2) : ''}`}</TopRowBox>
      <TopRowBox width="100px" backgroundColor={colors.grey} color={colors.lightGrey}>{`Ask: ${ask !== undefined ? ask.toFixed(2) : ''}`}</TopRowBox>
    </>
    // <div className={style.dataBoxContainer}>
    //   <div className={style.dataBox}>
    //     <p>
    //       <span className={style.dataLabel}>B: </span>
    //       <span className={style.data}>
    //         {bid !== undefined ? bid.toFixed(2) : ''}
    //       </span>
    //     </p>
    //   </div>
    //   <div className={style.dataBox}>
    //     <p>
    //       <span className={style.dataLabel}>A: </span>
    //       <span className={style.data}>
    //         {ask !== undefined ? ask.toFixed(2) : ''}
    //       </span>
    //     </p>
    //   </div>
    // </div>
  );
});

export default BidAskBox;
